<script setup lang="ts">
  interface Props {
    label1: string;
    label2: string;
    isFirst: boolean;
    size?: string;
    readonly?: boolean;
    disabled?: boolean;
  }
  const props = withDefaults(defineProps<Props>(), {
    size: "default",
    readonly: false,
  });

  interface Emits {
    (event: "update:isFirst", isFirst: boolean): void;
  }
  const emit = defineEmits<Emits>();
  const computedData = computed<boolean>({
    get: () => props.isFirst,
    set: value => {
      emit("update:isFirst", value);
    },
  });

  const onClick = (value: boolean) => {
    if (!props.readonly) {
      computedData.value = value; // readonly でなければ更新
    }
  };
</script>

<template>
  <div>
    <v-chip
      class="mr-4 my-2"
      :data-testid="`chip-switch-1`"
      :color="computedData ? 'primary' : 'default'"
      variant="flat"
      :size="size"
      :disabled="disabled"
      @click="onClick(true)"
    >
      {{ label1 }}
    </v-chip>
    <v-chip
      class="my-2"
      :data-testid="`chip-switch-2`"
      :color="!computedData ? 'primary' : 'default'"
      variant="flat"
      :size="size"
      :disabled="disabled"
      @click="onClick(false)"
    >
      {{ label2 }}
    </v-chip>
  </div>
</template>
